import React, {useEffect, useState} from 'react';
import moment from 'moment-timezone'
import axios from 'axios';

import { useNavigate } from 'react-router-dom';

import {Modal, Box, Grid, Typography, TextField, Button, IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function EditAssignmentModal(props) {
  const [assignment, setAssignment] = useState({});

  const navigate = useNavigate();

  function handleChange(field, value) {
    console.log(value)
    setAssignment({
      ...assignment,
      [field]: value,
    });
  }

  async function handleSubmit(event) {
    event.preventDefault();
    let newAssignment = assignment;
    newAssignment.timezone = moment.tz.guess();
    await axios.put(`${process.env.REACT_APP_API_HOST}/api/forms/assignments`, 
      newAssignment,
      {headers: {Authorization: `Bearer ${props.state.token.access_token}`}}
    )
    props.handleClose(newAssignment);
  }
  
  async function handleDelete() {
    await axios.delete(`${process.env.REACT_APP_API_HOST}/api/forms/assignments/${assignment.assignment_id}`, 
      {headers: {Authorization: `Bearer ${props.state.token.access_token}`}}
    )
    props.handleClose();
    navigate('/assignments', { state: props.state });
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    width: "60%",
    maxWidth: 550,
    minWidth: 300,
    maxHeight: 650,
    p: 3,
    borderRadius: 1,
    boxShadow: 24,
    overflowX: "auto",
  };

  useEffect(() => {
    setAssignment(props.state.assignment);
    console.log(props.state.assignment);
  }, [props.state])

  return (
    <Modal
      open={props.open}
      onClose={() => props.handleClose()}
      aria-labelledby="assign-to-class-modal"
      aria-describedby="enter-name-and-dates-for-assignment"
    >
      <Box component="form" sx={style} onSubmit={(event) => handleSubmit(event)}>
        <IconButton onClick={() => props.handleClose()} aria-label="close" style={{position: "absolute", right: "10px", top:"10px"}}>
          <CloseIcon />
        </IconButton>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h4">Edit Assignment</Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField required label="Name" variant="outlined" value={assignment?.name || ""} InputLabelProps={{shrink: true}} fullWidth onChange={(event) => handleChange("name", event.target.value)}/>
          </Grid>
          <Grid item xs={6}>
            <TextField
              id="start-date"
              required
              label="Start Date"
              type="date"
              fullWidth
              value={assignment?.startDate || ""}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(event) => handleChange("startDate", event.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id="start-time"
              required
              label="Start Time"
              type="time"
              fullWidth
              value={assignment?.startTime || ""}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(event) => handleChange("startTime", event.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id="end-date"
              required
              label="End Date"
              type="date"
              fullWidth
              value={assignment?.endDate || ""}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(event) => handleChange("endDate", event.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id="end-time"
              required
              label="End Time"
              type="time"
              fullWidth
              value={assignment?.endTime || ""}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(event) => handleChange("endTime", event.target.value)}
            />
          </Grid>
          <Grid item xs={12} sx={{display: "flex", justifyContent: "center", gap: 2}}>
            <Button variant="outlined" type="submit" onClick={() => handleDelete()} color="error" fullWidth>Delete</Button>
            <Button variant="outlined" onClick={() => props.handleClose()} fullWidth>Cancel</Button>
            <Button variant="contained" type="submit" fullWidth>Submit</Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export default EditAssignmentModal;